import React from 'react';

import PageContent from '../../../../../components/Layout/PageContent';
import { TableGridApiContextProvider } from '../../../../../components/TableGrid/TableGridApiContext/TableGridApiContext';
import CompaniesMatrixTable from './CompaniesMatrixTable';

const CompaniesMatrix: React.FC = () => {
  return (
    <PageContent isPageHeightAuto={false}>
      <TableGridApiContextProvider>
        <CompaniesMatrixTable />
      </TableGridApiContextProvider>
    </PageContent>
  );
};

export default CompaniesMatrix;
